import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../components/Converter";
import { RowBody } from "../../../components/RowValue/RowBody";
import {
  selectWerkstoffUebergangsrohr,
  setWerkstoffUebergangsrohr,
} from "../../../store/slices/pileHeadConstructionSlice";

function TransitionTubeMaterial() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const druckMode = useSelector(selectWerkstoffUebergangsrohr, Object.is);

  return (
    <RowBody
      titleValue={<p>{t("aeussre.transitionTubeMaterial")}</p>}
      inputValue={
        <select
          className={getClassName(String(druckMode) !== "NaN" ? true : false)}
          onChange={(e) => dispatch(setWerkstoffUebergangsrohr(Number(e.target.value)))}
          value={druckMode}
        >
          <option value={Number.NaN}>{t("select")}</option>
          <option value={0}>{t("aeussre.plasticTube")}</option>
          <option value={1}>{t("aeussre.steelTube")}</option>
        </select>
      }
    />
  );
}

export default TransitionTubeMaterial;
